import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/mjwy/Home'
import ArticleList from '@/components/mjwy/home/ArticleList'
import ArticleDetail from '@/components/mjwy/home/ArticleDetail'
import NotFound from '@/components/mjwy/NotFound'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/article',
      name: 'articleList',
      component: ArticleList
    },
    {
      path: '/article/:id',
      name: 'articleDetail',
      component: ArticleDetail
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0
  if (to.name === 'articleDetail') {
    const data = {id:to.params.id};
    axios.get('home/main/count',{params:data}).then(res=>{});  
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js